import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { RemoveAllFilters, chain } from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters"


type HandlerType = HandlerWithResult<
    {
        removeAll?: true;
    },
    ProductFilters
>;

export const RemoveAllFiltersCustom: HandlerType = props => {
    if (props.parameter.removeAll) {
        props.result.query = undefined;
        props.result.includeSuggestions = undefined;
    }
    props.result.stockedItemsOnly = undefined;
    props.result.previouslyPurchasedProducts = undefined;
    props.result.searchWithinQueries = undefined;
    props.result.brandIds = undefined;
    props.result.productLineIds = undefined;
    props.result.priceFilters = undefined;
    props.result.attributes = undefined;
    props.result.categoryId = undefined;
    props.result.page = undefined;
};


replaceInChain(chain, RemoveAllFilters, RemoveAllFiltersCustom);